<template>
  <div :key="$route.params.id">
    <PageHeader :items="items" />
    <b-tabs content-class="mt-2">
      <!-- Customer Tab -->
      <b-tab :title="$t('customer')">
        <validation-observer ref="simpleRules">
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Company Name"
                    rules="required"
                  >
                    <TextInput
                      v-model="form.companyName"
                      type="text"
                      :label="$t('companyName')"
                      :tooltipMessage="$t('companyName')"
                      :required="true"
                      :placeholder="$t('enterCompanyName')"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Address Line 1"
                    rules="required"
                  >
                    <TextInput
                      v-model="form.addressLine1"
                      type="text"
                      :label="$t('addressLine1')"
                      :required="true"
                      :placeholder="$t('enterAddressLine1')"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <TextInput
                    v-model="form.addressLine2"
                    type="text"
                    :label="$t('addressLine2')"
                    :placeholder="$t('enterAddressLine2')"
                  />
                </b-col>
                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <validation-provider
                    #default="{ errors }"
                    name="City"
                    rules="required"
                  >
                    <TextInput
                      v-model="form.city"
                      type="text"
                      :label="$t('city')"
                      :required="true"
                      :placeholder="$t('enterCity')"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <TextInput
                    v-model="form.shortName"
                    type="text"
                    :label="$t('shortName')"
                    :tooltipMessage="$t('shortName')"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <validation-provider
                    #default="{ errors }"
                    name="ZIP"
                    rules="required"
                  >
                    <TextInput
                      v-model="form.zipCode"
                      type="text"
                      :label="$t('zip')"
                      :required="true"
                      :placeholder="$t('enterZip')"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <div class="form-group">
                    <label class="form-label input-label" for="country"
                      >{{ $t("country") }}&nbsp;<span style="color: red"
                        >*</span
                      ></label
                    >
                    <validation-provider
                      #default="{ errors }"
                      name="Country"
                      rules="required"
                    >
                      <multi-select
                        :multiple="false"
                        label="name"
                        track-by="name"
                        :options="countries"
                        :key="countries"
                        v-model="form.country"
                        :class="{ 'is-invalid': errors[0] }"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </b-col>
                <b-col cols="12" :lg="showCreatedBy ? 4 : 6" :md="showCreatedBy ? 4 : 6" class="mb-1">
                  <TextInput
                    v-model="form.vatId"
                    type="text"
                    :label="$t('vatId')"
                    :placeholder="'+123XXXXXX'"
                  />
                </b-col>
                <b-col cols="12" :lg="showCreatedBy ? 4 : 6" :md="showCreatedBy ? 4 : 6" class="mb-1">
                  <TextInput
                    v-model="form.phone"
                    type="text"
                    :label="$t('phone')"
                    placeholder="+49XXXXXXXXXXX"
                  />
                </b-col>
                <b-col v-if="showCreatedBy" cols="12" lg="4" md="4" class="mb-1">
                  <TextInput
                    v-model="form.createdBy"
                    type="text"
                    :label="$t('createdBy')"
                    :disabled="true"
                  />
                </b-col>
                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <label class="input-label form-label" for="cars">{{
                    $t("status")
                  }}</label>
                  <select class="input-form form-control" v-model="form.status">
                    <option value="new">
                    {{ $t("new") }}
                  </option>
                  <option value="test">
                    {{ $t("test") }}
                  </option>
                  <option value="active">
                    {{ $t("active") }}
                  </option>
                  <option value="inactive">
                    {{ $t("inactive") }}
                  </option>
                  </select>
                </b-col>
                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <label class="input-label form-label">{{
                    $t("type")
                  }}</label>
                  <select class="input-form form-control" v-model="form.type">
                    <option value="">
                      {{ $t("selectOption") }}
                    </option>
                    <option value="practice">
                      practice
                    </option>
                    <option value="lab">
                      lab
                    </option>
                    <option value="other">
                      other
                    </option>
                  </select>
                </b-col>
                <div class="col-md-4 mb-1">
                  <b-form-group class="m-0">
                    <label class="input-label form-label"
                      >{{ $t("preferredContactLanguage") }}&nbsp;<span
                        style="color: red"
                        >*</span
                      >
                    </label>
                    <validation-provider
                      #default="{ errors }"
                      name="Contact Language"
                      rules="required"
                    >
                      <select
                        class="form-control"
                        v-model="form.contactLanguage"
                        :class="{ 'is-invalid': errors[0] }"
                      >
                        <option
                          v-for="language in languages"
                          :value="language"
                          :key="language"
                        >
                          {{ language }}
                        </option>
                      </select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-4 mb-1">
                  <b-form-group class="m-0">
                    <label class="input-label form-label" for="cars">
                      {{ $t("Owners") }}
                    </label>
                    <MultiSelectInput
                      v-model="form.owners"
                      :options="modifiedUsers"
                      :label="'full_name'"
                      trackBy="id"
                      :key="form.owners"
                      :query="{ company_id: $route.params.id }"
                      moduleName="users"
                      :multiple="true"
                      :searchParamName="`search_string`"
                      ><template #option="{ props }">
                        <div>
                          <p>
                            {{ props.option.first_name }}
                            {{ props.option.last_name }}
                          </p>
                        </div>
                      </template>
                    </MultiSelectInput>
                  </b-form-group>
                </div>
                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <div class="form-group">
                    <label class="input-label form-label"
                      >{{ $t("assignedToSalesPartner") }}&nbsp;<span
                        style="color: red"
                        >*</span
                      >
                    </label>
                    <validation-provider
                      #default="{ errors }"
                      name="Sales Partner"
                      rules="required"
                    >
                      <MultiSelectInput
                        :key="form.salesPartnerId"
                        v-model="form.salesPartnerId"
                        :options="salesPartners"
                        label="companyName"
                        trackBy="id"
                        moduleName="customers"
                        :multiple="false"
                        :action="'salesPartners'"
                    :query="{ isSalesPartner: true, isMultiSelect: true }"
                        :error="errors[0]"
                        ><template #option="{ props }">
                          <div>
                            <p>
                              {{ props.option.companyNumber }} -
                              {{ props.option.companyName }}
                            </p>
                          </div>
                        </template>
                      </MultiSelectInput>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </b-col>
                <!-- <b-col cols="12" lg="4" md="4" class="mb-1">
                  <div class="form-group">
                    <label class="input-label form-label"
                      >{{ $t("assignedToReseller") }}&nbsp;<span
                        style="color: red"
                        >*</span
                      >
                    </label>
                    <validation-provider
                      #default="{ errors }"
                      name="Reseller"
                      rules="required"
                    >
                      <MultiSelectInput
                        :key="form.resellerId"
                        v-model="form.resellerId"
                        :options="resellers"
                        label="companyName"
                        trackBy="id"
                        moduleName="customers"
                        :multiple="false"
                        :action="'resellers'"
                        :query="{ isReseller: true }"
                        :error="errors[0]"
                        ><template #option="{ props }">
                          <div>
                            <p>
                              {{ props.option.companyNumber }} -
                              {{ props.option.companyName }}
                            </p>
                          </div>
                        </template>
                      </MultiSelectInput>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </b-col>

                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <div class="form-group">
                    <label class="input-label form-label"
                      >{{ $t("assignedToServicePartner") }}&nbsp;<span
                        style="color: red"
                        >*</span
                      >
                    </label>
                    <validation-provider
                      #default="{ errors }"
                      name="Service Partner"
                      rules="required"
                    >
                      <MultiSelectInput
                        v-model="form.servicePartnerId"
                        :key="form.servicePartnerId"
                        :options="servicePartners"
                        label="companyName"
                        trackBy="id"
                        moduleName="customers"
                        :multiple="false"
                        :action="'servicePartners'"
                        :query="{ isServicePartner: true }"
                        ><template #option="{ props }">
                          <div>
                            <p>
                              {{ props.option.companyNumber }} -
                              {{ props.option.companyName }}
                            </p>
                          </div>
                        </template>
                      </MultiSelectInput>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </b-col> -->
                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <div class="form-group mt-1">
                    <label class="input-label form-label" for="cars">{{
                      $t("salesPartner")
                    }}</label>

                    <input
                      id="salesPartner"
                      :disabled="!$can('company-sales-partner-check.edit')"
                      class="form-check-input-custom ml-2"
                      v-model="form.salesPartner"
                      type="checkbox"
                    />
                  </div>
                </b-col>
                <!-- <b-col cols="12" lg="4" md="4" class="mb-1">
                  <div class="form-group mt-1">
                    <label class="input-label form-label" for="cars">{{
                      $t("commercialAgent")
                    }}</label>
                    <input
                      id="commercialAgent"
                      class="form-check-input-custom ml-2"
                      v-model="form.commercialAgent"
                      type="checkbox"
                    />
                  </div>
                </b-col> -->
                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <div class="form-group mt-1">
                    <label class="input-label form-label" for="affiliate">
                      {{ $t("affiliate") }}
                    </label>
                    <input
                      id="affiliate"
                      class="form-check-input-custom ml-2"
                      v-model="form.affiliate"
                      type="checkbox"
                    />
                  </div>
                </b-col>
                <b-col cols="12" lg="4" md="4" class="mb-1">
                  <div class="form-group mt-1">
                    <label class="input-label form-label" for="userGuide">
                      {{ $t("userGuide") }}
                    </label>
                    <input
                      id="userGuide"
                      class="form-check-input-custom ml-2"
                      v-model="form.userGuide"
                      type="checkbox"
                    />
                  </div>
                </b-col>
                <b-col lg="4" md="4" cols="12" class="mb-1">
                  <label class="input-label form-label">
                    {{ $t("salesPerson") }}
                  </label>
                  <MultiSelectInput
                    v-model="form.salesPerson"
                    :options="modifiedSalesPersons"
                    :label="'full_name'"
                    trackBy="id"
                    :key="form.salesPerson"
                    :multiple="false"
                    moduleName="auth"
                    :action="'salesPersons'"
                    :searchParamName="'search_string'"
                  >
                    <template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.first_name }} {{ props.option.last_name }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                </b-col>
                <b-col lg="4" md="4" cols="12" class="mb-1">
                  <label class="input-label form-label">
                    {{ $t("referralLink") }}
                  </label>
                  <MultiSelectInput
                    v-model="form.referralLinkId"
                    :options="referralLinks"
                     label="name"
                    trackBy="referralId"
                    :key="form.referralLinkId"
                    :multiple="false"
                    moduleName="referralLinks"
                    :action="'getReferralLinks'"
                  >
                  </MultiSelectInput>
                </b-col>
                
                <!-- <b-col
                  v-if="form.salesPartner"
                  cols="12"
                  lg="12"
                  md="12"
                  class="mb-1"
                >
                  <div class="form-group mt-1">
                    <label class="input-label form-label" for="cars">{{
                      $t("canEditCommissions")
                    }}</label>

                    <input
                      id="salesPartner"
                      class="form-check-input-custom ml-2"
                      v-model="form.canEditCommissions"
                      type="checkbox"
                    />
                  </div>
                </b-col>
                <b-col cols="12" lg="3" md="3" class="mb-1">
                  <text-input
                    :type="'number'"
                    v-model="form.commDistance1"
                    :label="$t('commDistance1')"
                    :disabled="isCommissionDisabled"
                    aria-label="Commission Distance 1"
                  />
                </b-col>
                <b-col cols="12" lg="3" md="3" class="mb-1">
                  <text-input
                    :type="'number'"
                    v-model="form.commDistance2"
                    :label="$t('commDistance2')"
                    :disabled="isCommissionDisabled"
                    aria-label="Commission Distance 2"
                  />
                </b-col>
                <b-col cols="12" lg="3" md="3" class="mb-1">
                  <text-input
                    :type="'number'"
                    v-model="form.commDistance3"
                    :label="$t('commDistance3')"
                    :disabled="isCommissionDisabled"
                    aria-label="Commission Distance 3"
                  />
                </b-col>
                <b-col cols="12" lg="2" md="2" class="mb-1">
                  <text-input
                    :type="'number'"
                    v-model="form.commDistanceN"
                    :label="$t('commDistanceN')"
                    :disabled="isCommissionDisabled"
                    aria-label="Commission Distance N"
                  />
                </b-col> -->
                <!-- <b-col
                  v-if="canEditCommission || $hasRole('admin')"
                  cols="12"
                  lg="1"
                  md="1"
                  class="d-flex justify-content-center"
                >
                  <feather-icon
                    @click="isLockedCommission = !isLockedCommission"
                    :icon="isLockedCommission ? 'LockIcon' : 'UnlockIcon'"
                    size="20"
                    class="cursor-pointer my-auto"
                    :aria-label="
                      isLockedCommission
                        ? 'Commission Distance Locked'
                        : 'Commission Distance Unlocked'
                    "
                  />
                </b-col> -->
              </b-row>
            </div>
          </div>
          <div class="card">
            <div class="card-header" aria-label="Payment Details Header">
              <h3 class="card-title">
                {{ $t("paymentDetails") }}
              </h3>
            </div>

            <div class="card-body" aria-label="Payment Detials Body">
              <b-row>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <text-input
                    v-model="form.invoiceEmailAddress"
                    :label="$t('invoiceEmailAddress')"
                    aria-label="Invoice Email Address Input"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Company Email"
                    rules="required"
                  >
                    <text-input
                      v-model="form.companyEmail"
                      :label="$t('companyEmail')"
                      :required="true"
                      :error="errors[0]"
                      aria-label="Company Email Input"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <text-input
                    v-model="form.warningMailAddress"
                    :label="$t('warningMailAddress')"
                    aria-label="Invoice Email Address Input"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <label class="input-label form-label" for="cars">{{
                    $t("applyReverseCharge")
                  }}</label>

                  <input
                    id="active"
                    class="form-check-input-custom ml-2"
                    v-model="form.applyReverseCharge"
                    type="checkbox"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <text-input
                    v-model="form.externalOrderNumber"
                    :label="$t('externalOrderNumber')"
                    aria-label="External Order Number"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <TextInput
                    v-model="form.pricePerUnit"
                    type="number"
                    :min="0"
                    :label="$t('pricePerUnit')"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <TextInput
                    v-model="form.dentawaxPricePerUnit"
                    type="number"
                    :min="0"
                    :label="$t('dentawaxPricePerUnit')"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <TextInput
                    v-model="form.dentaTempPricePerUnit"
                    type="number"
                    :min="0"
                    :label="$t('dentaTempPricePerUnit')"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <div class="form-group">
                    <label class="form-label input-label">
                      {{ $t("payingCurrency") }}
                    </label>
                    <multi-select
                      v-model="form.payingCurrency"
                      :multiple="false"
                      label="label"
                      track-by="country"
                      :options="countryCurrencies"
                      :placeholder="$t('selectOption')"
                    />
                  </div>
                </b-col>
                <!-- <b-col cols="12" lg="3" md="3" class="mb-1">
                  <text-input
                    :type="'number'"
                    v-model="credits"
                    :label="$t('dentalTwinCredits')"
                    :disabled="true"
                    aria-label=" Credits"
                  />
                </b-col>
                <b-col cols="12" lg="3" md="3" class="mb-1">
                  <text-input
                    :type="'number'"
                    v-model="form.credits"
                    :label="$t('enterFreeCredits')"
                    :disabled="!$can('backoffice-dentaltwin-coins.edit')"
                    aria-label=" Credits"
                  />
                </b-col> -->
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <text-input
                    v-model="form.notificationMail"
                    :label="$t('notificationMail')"
                    aria-label="Notification Mail"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <TextInput
                    v-model="form.freeCases"
                    type="number"
                    :label="$t('freeCases')"
                    :tooltipMessage="$t('freeCases')"
                    :required="false"
                  />
                </b-col>
                <b-col cols="12" lg="6" md="6" class="mb-1">
                  <DatePicker
                    v-model="freeCasesExpiryDate"
                    :label="$t('freeCasesExpiryDate')"
                    :required="false"
                    :isLeftIcon="true"
                    :options="{
                      enableTime: false,
                    }"
                    :leftIconName="'dateIcon'"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
          
          <BankDetails v-model="form.bankDetails" />

          <div class="d-flex align-items-center justify-content-end gap-2">
            <router-link
              to="/customers"
              class="d-flex align-items-center gap-1 btn btn-secondary"
            >
              <feather-icon icon="XIcon" size="12" />
              <span>{{ $t("cancel") }}</span>
            </router-link>
            <b-button
              variant="primary"
              @click="updateCustomer"
              class="d-flex align-items-center gap-1"
              :disabled="isFormInvalid"
              v-if="$can(`${$route.meta.permission}.edit`)"
            >
              <feather-icon icon="PlusIcon" size="12" />
              <span>{{ $t("updateCustomer") }}</span>
            </b-button>
          </div>
        </validation-observer>
      </b-tab>
      <b-tab v-if="$can('list-users')" :title="$t('users')" lazy>
        <Users />
      </b-tab>
      <b-tab :title="$t('creditFlows')" lazy>
        <Balances />
      </b-tab>
      <b-tab :title="$t('creditHistory')" lazy>
        <CreditHistory />
      </b-tab>
      <b-tab :title="$t('cases')" lazy>
        <CasesIndex :embedded="true" :companyId="$route.params.id" />
      </b-tab>
      <b-tab
        :title="$t('referralLinks')"
        v-if="$can('backoffice-referral-link.list')"
        lazy
      >
        <ReferralLinks :isShow="true" />
      </b-tab>
      <b-tab
        v-if="$can('backoffice-referral.list')"
        :title="$t('referral')"
        lazy
      >
        <Referral :isShow="true" />
      </b-tab>
      <b-tab
        v-if="
          $can('backoffice.customer-activity.list') ||
          $can('backoffice.customer-note.list')
        "
        :title="$t('activityHistory')"
        lazy
      >
        <ActivityHistory :companyName="form.companyName" :notificationMail="form.notificationMail" />
      </b-tab>
      <b-tab v-if="$can('backoffice.customer.merge')" :title="$t('mergeCompany')" lazy>
        <MergeCompany :company="currentCompany" :usersCount="usersCount" />
      </b-tab>
      <!-- <b-tab :title="$t('commissions')" lazy>
        <Commissions />
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import Users from "./components/Users.vue";
import BankDetails from "./components/BankDetails.vue";
import formDirtyMixin from "@/mixins/formDirtyMixin";
import Balances from "./components/Balances.vue";
// import Commissions from "./components/Commissions.vue";
import CreditHistory from "./components/CreditHistory.vue";
import CasesIndex from "@/views/my-cases/Index.vue";
import ActivityHistory from "./components/ActivityHistory.vue";
import MergeCompany from "./components/MergeCompany.vue";
import PageHeader from "@/components/PageHeader.vue";
import MultiSelect from "vue-multiselect";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import Referral from "@/views/referral/components/Referral.vue";
import ReferralLinks from "@/views/referral/components/ReferralLinks.vue";
import NotificationService from "@/services/notification.service";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { required, email } from "@validations";
import countries from "@/assets/data/countries.json";
import DatePicker from "@/components/DatePicker.vue";
import countryCurrencies from "@/assets/data/country-currencies.json";

export default {
  components: {
    TextInput,
    PageHeader,
    MultiSelect,
    ValidationProvider,
    ValidationObserver,
    MultiSelectInput,
    Balances,
    Users,
    CreditHistory,
    CasesIndex,
    Referral,
    ReferralLinks,
    ActivityHistory,
    MergeCompany,
    BankDetails,
    // Commissions,
    DatePicker,
  },
  mixins: [formDirtyMixin],
  computed: {
    ...mapGetters("users", ["users"]),
    ...mapGetters("auth", ["salesPersons"]),
    ...mapGetters("customers", [
      "resellers",
      "salesPartners",
      "servicePartners",
    ]),
    ...mapGetters("referralLinks", ["referralLinks"]),
    // isCommissionDisabled() {
    //   return !(this.canEditCommission || this.$hasRole('admin')) || this.isLockedCommission;
    // },
    modifiedUsers() {
      return this.users.map((user) => ({
        ...user,
        full_name: `${user.first_name} ${user.last_name}`,
      }));
    },
    modifiedSalesPersons() {
      if (!this.salesPersons || !Array.isArray(this.salesPersons)) {
        return [];
      }
      return this.salesPersons
        .filter((salesPerson) => {
          return salesPerson.roles && Array.isArray(salesPerson.roles) && salesPerson.roles.includes("admin");
        })
        .map((salesPerson) => ({
          ...salesPerson,
          full_name: `${salesPerson.first_name} ${salesPerson.last_name}`,
        }));
    },
    showCreatedBy() {
      return this.form.createdBy && this.form.createdBy.trim() !== "";
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("customers"),
          to: "/customers",
        },
        {
          html: `${this.$t("edit")}${this.form.companyName ? ' <strong>[' + this.form.companyName + ']</strong>' : ''}`,
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
        !this.form.companyName ||
        !this.form.addressLine1 ||
        !this.form.city ||
        !this.form.zipCode ||
        !this.form.country ||
        !this.form.salesPartnerId
      );
    },
  },
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
    "$route.params.id"(id, previousId) {
      if (!id || id === previousId) return;
      this.loadPage();
    },
  },
  data() {
    return {
      countries,
      countryCurrencies,
      languages: ["English", "French", "German", "Spanish", "Turkish"],
      originalForm: null,
      referralServiceBaseUrl: process.env.VUE_APP_REFERRAL_BASEURL || "",
      // credits: "",
      isLockedCommission: true,
      freeCasesExpiryDate: null,
      // canEditCommission: false,
      form: {
        companyName: "",
        companyEmail: "",
        shortName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        zipCode: "",
        country: "",
        // credits: "",
        contactLanguage: "",
        vatId: "",
        phone: "",
        referralLinkId: "",
        createdBy: "",
        status: "",
        type: "",
        usersCount: 0,
        // commDistance1: "",
        // commDistance2: "",
        // commDistance3: "",
        // commDistanceN: "",
        owners: [],
        // servicePartner: false,
        servicePartnerId: "",
        bankDetails: [],
        externalOrderNumber: "",
        pricePerUnit: "",
        dentawaxPricePerUnit: "",
        dentaTempPricePerUnit: "",
        payingCurrency: null,
        invoiceEmailAddress: "",
        warningMailAddress: "",
        applyReverseCharge: false,
        resellerId: "",
        salesPartnerId: "",
        // commercialAgent: false,
        affiliate: false,
        userGuide: false,
        // canEditCommissions: false,
        // reseller: false,
        // endUser: false,
        salesPartner: false,
        notificationMail: "",
        freeCases: "",
        salesPerson: null,
        // freeTestLowerTeeth: "",
        // freeTestUpperTeeth: "",
      },
      currentCompany: {},
      usersCount: 0,
    };
  },
  async created() {
    await this.loadPage();
  },
  methods: {
    async loadPage() {
      try {
        this.$store.commit("showLoader", true);
        this.isFormDirty = false;
        const responseUser = await this.$store.dispatch("users/list", {
          company_id: this.$route.params.id,
        });
        this.usersCount = responseUser?.data?.count;
        await this.loadUsers();
        this.$store.dispatch("referralLinks/getReferralLinks");
        await this.$store.dispatch("customers/salesPartners", {
          isSalesPartner: true,
        });
        await this.loadItems();
        this.$store.commit("showLoader", false);
      } catch (e) {
        console.error("api error ___", e);
        this.$store.commit("showLoader", false);
      }
    },
    async loadUsers() {
      await this.$store.dispatch("auth/salesPersons");
    },
    async loadItems() {
      try {
        await this.$store
          .dispatch("customers/show", this.$route.params.id)
          .then(async (res) => {
            let data = res?.data?.modelData;
            this.currentCompany = data || {};
            this.form.salesPerson = null;
            this.form.createdBy = "";
            this.form.companyName = data.companyName;
            this.form.companyEmail = data.companyEmail || "";
            this.form.shortName = data.shortName || "";
            this.form.addressLine1 = data.addressLine1;
            this.form.addressLine2 = data.addressLine2;
            this.form.userGuide = data.userGuide;
            // this.canEditCommission = data.canEditCommission;
            // this.form.commDistance1 = data.commDistance1;
            // this.form.commDistance2 = data.commDistance2;
            // this.form.commDistance3 = data.commDistance3;
            // this.form.commDistanceN = data.commDistanceN;
            
            this.form.zipCode = data.zipCode;
            // this.credits = data.credits;
            this.form.city = data.city;
            this.form.status = data.status;
            this.form.type = data.type || "";
            // this.form.freeTestUpperTeeth = data.freeTestUpperTeeth;
            this.form.contactLanguage = data.preferredContactLanguage;
            this.form.freeCases = data.freeCases;
            this.freeCasesExpiryDate = data.freeCasesExpiryDate;
            const matchedFormCountry = this.countries.find(
              (country) => country.name === data.country
            );
            this.form.country = matchedFormCountry || null;
            this.form.externalOrderNumber = data.externalOrderNumber;
            this.form.pricePerUnit = data.pricePerUnit ?? "";
            this.form.dentawaxPricePerUnit = data.dentawaxPricePerUnit ?? "";
            this.form.dentaTempPricePerUnit = data.dentaTempPricePerUnit ?? "";
            const payingCurrencyValue =
              data.payingCurrency ?? data.payingCurrency ?? "";
            this.form.payingCurrency =
              this.countryCurrencies.find(
                (item) => item.currency === String(payingCurrencyValue).toLowerCase()
              ) || null;
            this.form.vatId = data.vatId;
            this.form.phone = data.phone;
            this.form.invoiceEmailAddress = data.invoiceEmailAddress;
            this.form.warningMailAddress = data.warningMailAddress;
            this.form.owners = this.modifiedUsers.filter((user) =>
              data.owners.includes(user.id)
            );
            this.form.bankDetails = data.bankDetails.map((bank) => {
              const matchedCountry = this.countries.find(
                (country) => country.name === bank.country_name
              );

              return {
                bankName: bank.bankName || "",
                swift: bank.swift || "",
                iban: bank.iban || "",
                routing_number: bank.routing_number || "",
                account_number: bank.account_number || "",
                institution_number: bank.institution_number || "",
                transit_number: bank.transit_number || "",
                bsb_code: bank.bsb_code || "",
                branch_code: bank.branch_code || "",
                bank_code: bank.bank_code || "",
                country: matchedCountry || null, // multiselect expects object
              };
            });

            this.form.notificationMail = data.notificationMail;
            this.form.applyReverseCharge = data.applyReverseCharge;
            // this.form.reseller = data.reseller;
            this.form.salesPartner = data.salesPartner;
            // this.form.endUser = data.endUser;
            // this.form.servicePartner = data.servicePartner;
            // this.form.commercialAgent = data.commercialAgent;
            this.form.affiliate = data.affiliate;
            // this.form.canEditCommissions = data.canEditCommissions;
            this.form.resellerId = data.resellerCompany;
            this.form.servicePartnerId = data.servicePartnerCompany;
            this.form.salesPartnerId = data.salesPartnerCompany;
            this.form.referralLinkId = data.referralLink;
            if (data.salesPerson) {
              this.$store.dispatch("users/show", {
                id: data.salesPerson,
              }).then(response => {
                this.form.salesPerson = response?.data;
                this.form.salesPerson.full_name = `${this.form.salesPerson.first_name} ${this.form.salesPerson.last_name}`;
              });
            }

            // Handle referral and createdBy logic
            if (data.referral) {
              this.form.createdBy = data.referral;
            } else if (data.createdBy) {
              try {
                const userResponse = await this.$store.dispatch("users/show", {
                  id: data.createdBy
                });
                if (userResponse?.data?.first_name && userResponse?.data?.last_name) {
                  this.form.createdBy = `${userResponse.data.first_name} ${userResponse.data.last_name}`;
                }
              } catch (error) {
                this.form.createdBy = "";
              }
            }

            this.originalForm = JSON.stringify(this.form);
            this.isFormDirty = false;
          });
      } catch (e) {
        console.error("api error ___", e);
      }
    },
    async updateCustomer() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          if (this.usersCount > 0) {
            this.$store.commit("showLoader", true);
            await this.$store.dispatch("customers/update", {
              id: this.$route.params.id,
              data: {
                ...this.form,
                companyEmail: this.form.companyEmail || null,
                type: this.form.type || null,
                freeCasesExpiryDate: this.freeCasesExpiryDate || null,
                country: this.form.country.name ?? "",
                salesPartnerId: this.form.salesPartnerId?.id ?? "",
                owners: this.form.owners.map((user) => user.id),
                salesPersonId: this.form.salesPerson?.id ?? null,
                referralLinkId: this.form.referralLinkId?.referralId ?? null,
                payingCurrency: this.form.payingCurrency?.currency ?? null,
              },
            });
            this.$store.commit("showLoader", false);

            this.isFormDirty = false;
            this.originalForm = JSON.stringify(this.form);
            this.$router.push("/customers");
          } else {
            NotificationService.showError(
              "Please assign at least one user to this company"
            );
          }
        }
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}

/* .page-header {
  position: sticky !important;
  top: 10px !important;
  z-index: 1000 !important;
} */
</style>
